import { useDisclosure } from "@heroui/react";
import {
  ModalBuilder,
  ModalError,
  ModalField,
} from "@/app/components/modals/modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { loadHandbooks } from "@/utils/loadHandbooks";
import { LockSystem } from "@/api/lockSystems/lockSystems";

export function EditCustomSystemModal({
  disclosure,
  type,
  fields,
  lockSystem,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  type: string;
  fields: ModalField[];
  lockSystem: LockSystem | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: any) => {
    return new Promise<boolean>((resolve) => {
      api.lockSystems
        .update(lockSystem!.id, {
          display_name: data.displayName,
          type,
          credentials: data,
        })
        .then(() => {
          loadHandbooks({ handbooks: ["locks"] });
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          loadHandbooks({ handbooks: ["locks"] });
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>((resolve) => {
      api.lockSystems
        .delete(lockSystem!.id)
        .then(() => {
          resolve(true);
        })
        .catch((err) => {
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование системы"
      fields={[
        {
          name: "displayName",
          type: "text",
          label: "Название",
          isRequired: true,
          placeholder: "Название системы",
        },
        ...fields,
      ]}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      modalErrors={modalErrors}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isSensitiveData={true}
      submitButtonText="Сохранить"
      defaultValues={{
        displayName: lockSystem?.display_name,
        ...fields.reduce((acc: Record<string, string>, field) => {
          acc[field.name] = lockSystem?.credentials[field.name] || "";
          return acc;
        }, {}),
      }}
    />
  );
}
